(() => {
  const init = () => {
    document.querySelectorAll('.frh').forEach(root => {
      if (root.dataset.navigationReady) return;
      root.dataset.navigationReady = 'true';
      root.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#frh-categories-"]');
        if (!link) return;
        const target = document.getElementById(link.getAttribute('href').slice(1));
        if (!target) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
      },true);
    });
  };
  init();
  document.addEventListener('shopify:section:load',init);
})();
